<template>
  <div>
    <b-message type="is-dark">
      <apart class="has-padding-0">
        <p>Create a new product.</p>
        <button
          class="button is-dark is-rounded is-outlined"
          @click="addProduct"
        >
          Create product
        </button>
      </apart>
    </b-message>

    <loading v-if="loading" />

    <div v-else>
      <b-table
        ref="table"
        :data="sortedProducts"
        :mobile-cards="true"
        :detailed="true"
        hoverable
        striped
        :show-detail-icon="true"
        detail-key="_id"
        class="has-vertical-align-middle"
        @click="$emit('edit', $event)"
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Name" width="300">
            <status-label
              :status="props.row.isActive ? 'active' : 'discontinued'"
            />
            <span class="has-margin-left-50">{{ props.row.name }}</span>
          </b-table-column>

          <b-table-column label="Type">{{ props.row.type }}</b-table-column>

          <b-table-column
            label="Date created"
            field="dateCreated"
            width="180"
            >{{
              $moment(props.row.dateCreated.toDate()).from()
            }}</b-table-column
          >

          <b-table-column custom-key="edit-controls" width="1">
            <button class="button" @click="$emit('edit', props.row)">
              Edit
            </button>
          </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <p>{{ props.row.description }}</p>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { collection, doc, getDocs } from "@firebase/firestore";
export default {
  name: "ProductsTable",
  data() {
    return {
      loading: true,
      products: {},
      processing: false
    };
  },
  computed: {
    sortedProducts() {
      return this.$_(this.products)
        .orderBy(["isActive", "dateCreated"], ["desc", "desc"])
        .value();
    }
  },
  created() {
    this.getProducts();
  },
  methods: {
    addProduct() {
      this.$modal.open({
        component: () => import("@shared/product/_productModal"),
        parent: this,
        width: 720,
        hasModalCard: true,
        canCancel: ["escape", "outside"],
        props: {
          productId: doc(collection(this.$firestore, `products`)).id
        }
      });
    },
    getProducts() {
      const productsRef = collection(this.$firestore, `products`);
      getDocs(productsRef)
        .then(snapshot => {
          snapshot.forEach(product => {
            this.$set(
              this.products,
              product.id,
              this.$_.merge({}, { _id: product.id }, product.data())
            );
          });

          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$toast.open({
            message: error.message,
            position: "is-bottom",
            type: "is-danger",
            queue: false
          });
        });
    }
  }
};
</script>
